<div class="annual-status-wrapper">
    <div class="status" [ngClass]="SignatureStatus[status!]">
        {{ SignatureStatus[status!] | splitByCapitalLetterPipe }}
        {{ status === SignatureStatus.Signed ? (signedOn ? (' - ' + (signedOn | date:'dd MMM yyyy')) : '') : '' }}
    </div>
</div>